import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

// Context
import AppContext from "./AppContext";

// Css
import "./Nav.css";

// Material Ui
// #Element
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
// #Transitions
import Zoom from "@material-ui/core/Zoom";
import Fade from "@material-ui/core/Fade";
// #Icons
import PeopleIcon from "@material-ui/icons/People";

function Nav() {
  const history = useHistory();
  const [currentPath, setCurrentPath] = useState();
  const { appContext, setAppContext } = useContext(AppContext);
  const { textFocus, toolBarOn } = appContext;

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, [window.location.pathname]);

  history.listen((location) => {
    setCurrentPath(window.location.pathname);
  });

  const handleEditFeed = () => {
    if (window.location.pathname === "/edit") {
      history.push("/feed");
    } else {
      setAppContext((prevState) => ({ ...prevState, toolBarOn: true }));
      history.push("/edit");
    }
    setCurrentPath(window.location.pathname);
  };
  return (
    <div>
      <nav className="nav">
        <div className="nav__feed">
          <Zoom in={!toolBarOn || currentPath == "/feed"}>
            <IconButton onClick={handleEditFeed}>
              {currentPath == "/edit" ? <PeopleIcon /> : <EditIcon />}
            </IconButton>
          </Zoom>
        </div>
        <Fade
          in={!textFocus}
          style={{ transitionDelay: "0.5s", transitionDuration: "1s" }}
        >
          <h1 className="nav__title">PAINTED TEXT</h1>
        </Fade>
      </nav>
    </div>
  );
}

export default Nav;
